function addToCartPopup(){
    console.log("osiuel")
    $('[js-atc-btn]').click(function(){
        $('[js-add-to-cart-wrapper]').addClass('active');
        jQuery.post('/cart/add.js', {
          items: [
            {  
              quantity: 1,
              id: $('[js-atc-btn]').attr('data-v-id'),
            }
          ]
        })
        .done(function(data) {
          data = JSON.parse(data);
          $('body').append(`
            <div class="main-pdp-popup" data-toggle="modal" >
              <div class="add-to-cart-notification">
                <div class="popup">
                  <div class="cross-svg crossBtnClose" id="crossBtn">
                    <svg width="10" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#A1A1A1" fill-rule="nonzero"></path></svg>
                  </div>
                  <div>
                    <div>
                      <h3 class="main-title">Agregado al carrito</h3>
                      <div class="image">
                        <img src=${data.items[0]['featured_image']['url']} 
                          width="50px" height="100px"
                        alt=${data.items[0]['featured_image']['alt']}
                        />
                      </div>
                      <h2 class="product-title" cart-popup-title>${data.items[0]['product_title']}</h2>
                      <!--
                      <div class="options">
                        ${renderHtm1(data.items[0])}
                        <p class="variants">Precio: <span class="price">${Utils.formatMoney(data.items[0].price /100)}</span> </p>

                      </div>-->
                        <div class="options">
                          <!--<p>Precio App Wholesale</p>-->
                          ${renderHtm1(data.items[0])}
                          <input type="hidden" data-wpd-cart-drawer-product-handle="${data.items[0].handle}" data-wpd-cart-drawer-variant-id="${data.items[0].variant_id}" data-wpd-cart-drawer-variant-price="${data.items[0].price}" data-wpd-cart-drawer-variant-compare-at-price="${data.items[0].original_price}" data-wpd-cart-drawer-product-id="${data.items[0].product_id}" data-wpd-cart-drawer-line-price data-wpd-cart-drawer-item="${data.items[0].key}" data-wpd-cart-drawer-quantity="${data.items[0].quantity}" />
                          <p class="variants">Precio: <span data-wpd-cart-drawer-product-handle="${data.items[0].handle}" data-wpd-cart-drawer-variant-id="${data.items[0].variant_id}" data-wpd-cart-drawer-variant-price="${data.items[0].price}" data-wpd-cart-drawer-variant-compare-at-price="${data.items[0].original_price}" data-wpd-cart-drawer-product-id="${data.items[0].product_id}" data-wpd-cart-drawer-item="${data.items[0].key}" data-wpd-cart-drawer-quantity="${data.items[0].quantity}" class="price">${Utils.formatMoney(data.items[0].price /100)}</span> </p>

                        </div>
                      <div class="buttons text-center">
                        <a href="/cart" class="btn btn-lg btn-dark" >Ir al Carrito</a>
                        <br>
                        <br>
                        <a href="javascript:;" class="btn btn-lg btn-dark crossBtnClose" >Seguir comprando</a></div>
                    </div>  
                  </div>
                </div>
              </div>
            </div>
            `)
  
          var theLinks = document.querySelectorAll('.add-to-cart-notification .nav-tabs a');
          var theContentLinks = document.querySelectorAll('.add-to-cart-notification .tab-content .tab-pane');
  
          theLinks.forEach(function (element, index) {
              var linkinterno = element.getAttribute("href");
              element.href = linkinterno + "Interna";
          });
          theContentLinks.forEach(function (element, index) {
              var contenidointerno = element.getAttribute("id");
              element.id = contenidointerno + "Interna";
          });
           
            function renderHtm1(item) {
              // <span class="size">${data.items[0].variant_options[1]} |</apan
                let elm = ''
                item.options_with_values.forEach(option => {
                  elm+= `<p class="variants">${option.name}: <span>${option.value}</span></p>`
                })
              return elm;
            }
  
            var replaced = $(".main-pdp-popup .options .variants:nth-child(2)").html().replace('Size','Talle'); // Obtenemos el texto a cambiar
            $(".main-pdp-popup .options .variants:nth-child(2)").html(replaced); // Cambiamos el texto
            
            $('[js-add-to-cart-wrapper]').removeClass('active');
            
            jQuery.getJSON('/cart.js').done(function(items){
              $('.site-header__cart .counter').html(items.item_count);
            })
  
            
          const tabBlock = $("#tab-block");
          const tabItem = tabBlock.find("[js-tab-item]");
          const tabPanel = tabBlock.find("[js-tab-panel]");
  
          tabItem.click(function() {
            const index = $(this).index();
  
            tabItem.removeClass('active');
            $(this).addClass('active');
  
            tabPanel.removeClass('active');
            tabPanel.eq(index).addClass('active');
            
          })
  
          $('.crossBtnClose').on('click', function() {
            // $('.main-pdp-popup').modal().hide()
            $('.main-pdp-popup').remove()
            $('[js-add-to-cart-wrapper]').removeClass('active');
          })
         
        })
        .fail(function() {
          $('[js-add-to-cart-wrapper]').removeClass('active');
       
          $('body').append(`
            <div class="add-to-cart-notification-fail">
              Ya agregaste este producto al carrito. No quedan más disponibles.
            </div>
          `)
          setTimeout(() => {
            $('.add-to-cart-notification-fail').remove();
          }, 2000)
  
        });
    })
}
addToCartPopup()
document.addEventListener("addToCartPopup:init", addToCartPopup);

class MainProduct extends HTMLElement {
    constructor() {
        super();
        this.variantFields = this.querySelectorAll("[js-variant-field]");
        this.productMediaGallery = document.querySelector("[js-product-media-gallery]");
        this.previousSize = null;
        this.selectedColor = null;
        this.init();
        this.setInitialCheckedStates();
    }

    init() {
        this.variantFields.forEach(field => field.addEventListener("click", this.handleVariantChange.bind(this)));
    }

    setInitialCheckedStates() {
      const checkedInputs = this.querySelectorAll('input[type="radio"]:checked');
  
      checkedInputs.forEach(input => {
        const name = input.name.toLowerCase();
  
        if (name.includes("color")) {
          this.selectedColor = input.id;
        }
  
        if (name.includes("size")) {
          this.previousSize = input.id;
        }
      });
    }

    handleVariantChange({ currentTarget }) {
        this.productDetail = currentTarget.closest('[js-product-detail]');
        if (!this.productDetail) {
            console.error('Product detail element not found');
            return;
        }

        const groupName = currentTarget.getAttribute("name");
        const name = groupName.toLowerCase();

        if (name.includes("color")) {
          this.selectedColor = currentTarget.id;
          this.clearSizeChecked();
        }

        if (name.includes("size")) {
          this.previousSize = currentTarget.id;
        }

        this.updateContent();
    }

    clearSizeChecked() {
      const sizeInputs = this.productDetail.querySelectorAll('input[name*="size"]');
      sizeInputs.forEach(input => input.checked = false);
      this.previousSize = null;
    }
    
    checkAndRemoveClass() {
      const sizeInput = this.previousSize
        ? this.productDetail.querySelector(`input[id="${this.previousSize}"]`)
        : null;
  
      if (sizeInput) {
        const wrapper = sizeInput.parentElement;
        if (wrapper) {
          wrapper.classList.remove("js-product-variants");
        }
      }
    }

    updateContent() {
    const variantData = JSON.parse(this.productDetail.querySelector('[type="application/json"]').textContent);
    
    const selectedInputs = Array.from(this.productDetail.querySelectorAll('input[type="radio"]:checked'));
    const selectedOptions = selectedInputs.map(input => ({
      name: input.name,
      value: input.value,
      id: input.id,
    }));

    const selectedMap = new Map(selectedOptions.map(opt => [opt.name.toLowerCase(), opt.value]));

    let currentVariant = variantData.find(variant => {
      return variant.options.every((opt, idx) => {
        const optionName = this.variantFields[idx]?.name.toLowerCase();
        return !optionName || selectedMap.get(optionName) === opt;
      });
    });

    if (!currentVariant && selectedOptions.length > 0) {
      currentVariant = variantData.find(variant => {
        return selectedOptions.every(sel => variant.options.includes(sel.value));
      });
    }

    if (currentVariant) {
      const url = `${this.dataset.url}?variant=${currentVariant.id}&section_id=${this.dataset.originalSection || this.dataset.section}`;
      this.updateURL(currentVariant.id);

      fetch(url)
        .then(res => res.text())
        .then(responseText => {
          const newDoc = new DOMParser().parseFromString(responseText, 'text/html');
          this.replaceContent(newDoc);
          this.updateImage(newDoc);
          this.checkAndRemoveClass();

          document.dispatchEvent(new Event('updateSliderEvent:init'));
          document.dispatchEvent(new Event('updateProductAcordion:init'));
          document.dispatchEvent(new Event('shippingPopupContent:init'));
          document.dispatchEvent(new Event('productSizeGuide:init'));
          document.dispatchEvent(new Event('updateImageZoom:init'));
          document.dispatchEvent(new Event('addToCartPopup:init'));
          document.dispatchEvent(new Event('CuotasPopupContent:init'));
          document.dispatchEvent(new CustomEvent('pdpswatchColor:init'));
        });
    }
    }

    replaceContent(newDocument) {
      const newContent = newDocument.querySelector('[js-product-detail]');
      if (!newContent) return;
  
      this.productDetail.innerHTML = newContent.innerHTML;
      this.variantFields = this.productDetail.querySelectorAll("[js-variant-field]");
      this.init();
  
      // ✅ Restore selected color
      if (this.selectedColor) {
        const colorInput = this.productDetail.querySelector(`input[id="${this.selectedColor}"]`);
        if (colorInput) colorInput.checked = true;
      }
  
      // ✅ Restore selected size
      if (this.previousSize) {
        const sizeInput = this.productDetail.querySelector(`input[id="${this.previousSize}"]`);
        if (sizeInput) sizeInput.checked = true;
      }
  
      this.checkAndRemoveClass();
    }

    updateURL(variantId) {
        const newUrl = `${this.dataset.url}?variant=${variantId}`;
        window.history.replaceState({}, '', newUrl);
    }

    updateImage(newDocument) {
        const ajaxMedia = newDocument.querySelector('[js-product-media-gallery]');
        console.log(ajaxMedia,'ajaxMedia')
        this.productMediaGallery.innerHTML = ajaxMedia.innerHTML;
    }
  
}

customElements.define('main-product', MainProduct);

